'use client';

import { captureAttribution } from '@repo/web-chrome/lib/analytics/attribution';
import { ga4GtagAdapter } from '@repo/web-chrome/lib/analytics/ga4-gtag-adapter';
import {
  useAnalyticsPageView,
  useFlushAttributionOnSession,
  useIdentifyUser,
  useLinkClickTracking,
  useScrollDepthTracking,
} from '@repo/web-chrome/lib/analytics/hooks';
import { useIdleMount } from '@repo/web-chrome/lib/use-idle-mount';
import { useLocale } from 'next-intl';
import { useEffect } from 'react';

function MountedAnalytics(): null {
  const locale = useLocale();

  useAnalyticsPageView();
  useScrollDepthTracking();
  useLinkClickTracking();
  useFlushAttributionOnSession();
  useIdentifyUser();

  useEffect(() => {
    captureAttribution();
  }, []);

  useEffect(() => {
    ga4GtagAdapter.setUserProperty('locale', locale);
  }, [locale]);

  return null;
}

export function AnalyticsProvider(): React.JSX.Element | null {
  const ready = useIdleMount();
  if (!ready) {
    return null;
  }
  return <MountedAnalytics />;
}
